export default {
  email: null,
  firstName: null,
  lastName: null,
  userlist: [],
  edituser: {},
};



// WEBPACK FOOTER //
// ./src/app/store/modules/account/state.js